import { FC } from 'react'
import { InPersonLayout } from 'room/common/presentation/video-layout/in-person-layout'
import { useStageSurface } from 'room/common/stage-surface'
import { useSimpleGroupingTask } from 'features/simple-grouping/use-simple-grouping-task'
import { useGroupWorkEnd } from '../use-group-work-end'
import { GroupWorkCard } from './group-work-card'

/**
 * The group-work screen. `SimpleGrouping` is only ever enabled by a stationary
 * interaction scheme, so this is an in-person screen by construction and uses
 * `InPersonLayout` rather than a video grid.
 *
 * Sized as the lobby is: for the back of the room on the projector, for a
 * laptop everywhere else. The task shows when group work has one - see
 * `useSimpleGroupingTask` for when it is absent - and the planned end when
 * the agenda has one (`useGroupWorkEnd`).
 */
export const SimpleGroupingFeature: FC = () => {
	const task = useSimpleGroupingTask()
	const backAt = useGroupWorkEnd()
	const onProjector = useStageSurface() === 'projector'

	return (
		<InPersonLayout>
			<GroupWorkCard
				size={onProjector ? 'room' : 'desktop'}
				name={task?.name}
				description={task?.description}
				backAt={backAt}
			/>
		</InPersonLayout>
	)
}
